import type { DataTableProps } from '../DataTable/public.api.js';

function generateData(
  nrOfRows: number,
  nrOfColumns: number,
  columnIdentifier: (index: number) => string,
) {
  return [...Array(nrOfRows).keys()].map((_item, rowIndex) => {
    const rowData = {};
    for (let colIndex = 0; colIndex < nrOfColumns; colIndex++) {
      rowData[columnIdentifier(colIndex)] = `Row:${rowIndex}-Col:${colIndex}`;
    }
    return rowData;
  });
}

function generateColumns(
  nrOfColumns: number,
  columnIdentifier: (index: number) => string,
) {
  return [...Array(nrOfColumns).keys()].map((_item, index) => ({
    id: columnIdentifier(index),
    header: `Col ${index}`,
    accessor: columnIdentifier(index),
  }));
}

/** Generates tabular test data */
export function generateTableData(
  nrOfRows: number = 100,
  nrOfColumns: number = 2,
): DataTableProps {
  const columnIdentifier = (index: number) => `col-${index}`;
  const columns = generateColumns(nrOfColumns, columnIdentifier);
  const data = generateData(nrOfRows, nrOfColumns, columnIdentifier);
  return { columns, data };
}
